export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-5 whitespace-nowrap">
              精选高分热门推荐
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 font-bold leading-tight mb-4">
              91在线视频
              <br className="md:hidden" />
              <span className="text-primary-600"> 精品影视在线平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              每日精选 · 高清流畅 · 即刻畅享
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              91在线视频汇聚海量<strong>精品影视</strong>与<strong>高分电影</strong>资源，覆盖动作大片、悬疑推理、科幻巨制、喜剧佳作等多元品类。
              每日更新<strong>热门推荐</strong>与<strong>精选视频</strong>清单，提供流畅高清在线播放体验，是您发现优质内容的一站式入口。
              无论经典重温还是新片尝鲜，91精品视频在线播放都能满足您的观影需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">20,000+</div>
                <div className="text-xs text-foreground-500 mt-1">精选片源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">内容新鲜</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">高清流畅</div>
                <div className="text-xs text-foreground-500 mt-1">不缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                探索专题合集
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3 border border-background-300 hover:border-primary-400 text-foreground-700 hover:text-primary-600 font-medium rounded-full text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                查看精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20composition%20with%20warm%20golden%20and%20coral%20accent%20lights%2C%20abstract%20film%20reel%20texture%20with%20soft%20bokeh%20effect%2C%20elegant%20entertainment%20atmosphere%2C%20curated%20premium%20video%20platform%20aesthetic%2C%20clean%20sophisticated%20background%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20lighting%20with%20lens%20flare%2C%20modern%20minimal%20design%20with%20dramatic%20shadows&width=960&height=720&seq=hero-main-visual-91&orientation=landscape"
                alt="91在线视频 - 精品影视在线平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/20 via-transparent to-accent-500/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}